import cx from 'classnames';
import React from 'react';
import { theme } from '@vimily/bonjoro-ui-components';

export const defaultTagColors = {
  turquoise : theme.colors.turquoise[300],
  yellow: theme.colors.yellow[300],
  purple: theme.colors.purple[300],
  pink: theme.colors.pink[300],
  orange: theme.colors.orange[300],
  blue: theme.colors.blue[300],
  red: theme.colors.red[300]
};

interface TagColorRadioButtonProps {
  name: string;
  tagColor: string;
  tagColorName: string;
  disabled?: boolean;
  checked?: boolean;
  containerClassName?: string;
  buttonClassName?: string;
  onClick?: () => void;
}

export default function TagColorRadioButton({
  name,
  tagColor,
  tagColorName,
  disabled = false,
  checked = false,
  containerClassName,
  buttonClassName,
  onClick
}: TagColorRadioButtonProps){
  const id = `${tagColorName}-${name}`;
  return (
    <label className={containerClassName}>
      <input type="radio" id={id} name={name} className="peer hidden" checked={checked} />
      <label 
        htmlFor={id} 
        className={cx(buttonClassName, 'rounded-full cursor-pointer my-0',
          {
            'hover:border-solid hover:border hover:border-turquoise-700': !disabled,
            'peer-checked:border-solid peer-checked:border-2 peer-checked:border-turquoise-700': !disabled,
          }
        )}
        style={{ backgroundColor: tagColor }}
        onClick={onClick}
      />
    </label>
  );
}